import { getHeaders, getNonJsonHeaders } from '../../../core/api';
import { host } from '../../../config';

export function fetchProfile(id) {
  return fetch(`${host}/api/profile/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function patchProfile(id, payload) {
  return fetch(`${host}/api/profile/${id}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function postSetPassword(id, payload) {
  return fetch(`${host}/api/profile/${id}/password/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function uploadProfileImage(id, acceptedFiles) {
  const formData = new FormData();
  formData.append('custom_image', acceptedFiles[0]);
  return fetch(`${host}/api/profile/${id}/`, {
    method: 'PATCH',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}

export function fetchTickets() {
  const auth = JSON.parse(sessionStorage.getItem('auth'));
  const email = auth.profile.user.email;
  let data = {}
  data.email = email
  return fetch(`${host}/api/support/tickets/get_all_tickets/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function fetchContact(payload) {
  const auth = JSON.parse(sessionStorage.getItem('auth'));
  const email = auth.profile.user.email;
  const Name = auth.profile.user.first_name + ',' + auth.profile.user.last_name;
  let data = {}
  data.email = email
  data.name = Name
  return fetch(`${host}/api/support/tickets/get_or_create_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function uploadTicketImage(payload) {
  const auth = JSON.parse(sessionStorage.getItem('auth'));
  const email = auth.profile.user.email;
  let data = {}
  data.email = email
  const formData = new FormData();
  formData.append('photo', payload.img);
  return fetch(`${host}/api/support/tickets/upload_attachment/`, {
    headers: getNonJsonHeaders(),
    method: 'POST',
    body: formData,
  });
}

export function createTicket(payload) {
  const auth = JSON.parse(sessionStorage.getItem('auth'));
  const email = auth.profile.user.email;
  let data = {}
  data.email = email
  return fetch(`${host}/api/support/tickets/create_ticket/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function createTicketAttachment(payload) {
  const auth = JSON.parse(sessionStorage.getItem('auth'));
  const email = auth.profile.user.email;
  let data = {}
  data.email = email
  return fetch(`${host}/api/support/tickets/create_ticket_attachment/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function fetchTicket(payload) {
  return fetch(`${host}/api/support/tickets/get_ticket/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function fetchComments(payload) {
  return fetch(`${host}/api/support/tickets/get_comments/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function postComment(payload) {
  return fetch(`${host}/api/support/tickets/add_comment/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function postAddHotelRoomPhoto(payload) {
  const formData = new FormData();
  formData.append('photo', payload.photo);
  formData.append('hotel_room_type', payload.hotel_room_type)
  return fetch(`${host}/api/property/hotelroomphoto/`, {
    headers: getNonJsonHeaders(),
    method: 'POST',
    body: formData
  });

}
  


// WEBPACK FOOTER //
// src/routes/support/modules/api.js